import React from 'react';
import pipe from 'lodash/fp/pipe';
import find from 'lodash/fp/find';
import get from 'lodash/fp/get';
import PropTypes from 'prop-types';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';
import { Alert } from 'antd';
import { compose, lifecycle } from 'recompose';

import withFormValues from '@sp/client/utils/withFormValues';
import * as planActions from '@sp/client/modules/plan/actions';

import renderInput from '../../components/form/Input';
import renderSelect from '../../components/form/Select';
import renderInputDate from '../../components/form/InputDate';
import renderVRM from '../../components/form/VRM';

import s from './form.less';

const formName = 'kam-new-sp';

class NewSpForm extends React.Component {
  static propTypes = {
    saveQuote: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
    fields: PropTypes.object,
    disabled: PropTypes.bool,
    dispatch: PropTypes.func,
    error: PropTypes.any,
  };

  static validateNotBlank(val) {
    if (!val) {
      return 'This field is required.';
    }
    return undefined;
  }

  static greaterThanZero(val) {
    if (val === '0') {
      return 'Mileage can not be less than 1';
    }
    return undefined;
  }

  static validateCar(val) {
    if (val === 'Choose a vehicle') {
      return 'This field is required.';
    }
    return undefined;
  }

  static validateDate(val) {
    try {
      if (!moment(val).isValid()) {
        throw new Error();
      }
    } catch (e) {
      return 'Invalid date';
    }
    return undefined;
  }

  static validateOptionalDate(val) {
    if (!val) {
      return undefined;
    }

    try {
      if (!moment(val).isValid()) {
        throw new Error();
      }
    } catch (e) {
      return 'Invalid date';
    }
    return undefined;
  }

  static lessThanNow(val) {
    try {
      if (moment(val).format('x') > moment().format('x')) {
        return 'This field can not contains future date';
      }
    } catch (e) {
      return 'Invalid date';
    }
    return undefined;
  }

  state = {
    plans: [],
    packageOptions: [],
  };

  term = [
    { text: '12 months', value: 1 },
    { text: '24 months', value: 2 },
    { text: '36 months', value: 3 },
  ];

  paymentType = [{ name: 'Upfront', value: 1 }, { name: 'Monthly', value: 2 }];

  async componentDidMount() {
    const plans = await fetch('/provider/plan-types');
    this.setState({
      plans,
      packageOptions: plans.map(x => ({
        text: x.name,
        value: x.id.toString(),
      })),
    });
  }

  componentWillReceiveProps = newProps => {
    const {
      change,
      fields: { PackageId },
    } = this.props;
    const packageCarsNumber = this.packageCarsNumber(newProps.fields.PackageId);

    if (newProps.fields.PackageId !== PackageId && packageCarsNumber !== 2) {
      change('VRN2', '');
    }
  };

  setLastServiceMileageKnown = e => {
    if (!e.target.checked) {
      this.props.change('lastServiceMileage', '');
      this.props.change('lastServiceDate', '');
      this.props.untouch(formName, 'lastServiceMileage', 'lastServiceDate');
    }
    this.props.change('lastServiceMileageKnown', e.target.checked);
    this.props.change('justServiced', false);
  };

  setVRN2LastServiceMileageKnown = e => {
    if (!e.target.checked) {
      this.props.change('VRN2LastServiceMileage', '');
      this.props.change('VRN2LastServiceDate', '');
      this.props.untouch(
        formName,
        'VRN2LastServiceMileage',
        'VRN2LastServiceDate',
      );
    }
    this.props.change('VRN2LastServiceMileageKnown', e.target.checked);
    this.props.change('VRN2JustServiced', false);
  };

  setJustServiced = e => {
    if (e.target.checked) {
      this.props.change('lastServiceMileage', this.props.fields.currentMileage);
      this.props.change('lastServiceDate', moment());
    }

    this.props.change('justServiced', e.target.checked);
  };

  setVRN2JustServiced = e => {
    if (e.target.checked) {
      this.props.change(
        'VRN2LastServiceMileage',
        this.props.fields.VRN2CurrentMileage,
      );
      this.props.change('VRN2LastServiceDate', moment());
    }

    this.props.change('VRN2JustServiced', e.target.checked);
  };

  validateLastMileage = val => {
    if (val > this.props.fields.currentMileage) {
      return 'Current mileage must be greater than or equal to last service Mileage';
    }
    return undefined;
  };

  validateVRN2LastMileage = val => {
    if (val > this.props.fields.VRN2CurrentMileage) {
      // eslint-disable-next-line quotes
      return "Current mileage must be greater than or equal to second car's last service Mileage";
    }
    return undefined;
  };

  servicesList = () => {
    const result = [{ text: 'Select', value: '', disabled: true }];
    if (this.props.fields.intervals) {
      for (let i = 1; i <= 10; i++) {
        result.push({
          text: `${12 * i} months/${12000 * i} miles`,
          value: i,
        });
      }
    }
    return result;
  };

  submit = async values => {
    const data = {
      PackageId: '',
      currentMileage: '',
      expectedMileage: '',
      customerEmail: '',
      requestedServicesCount: '',
      registeredDate: '',
      regNumId: '',
      registration: '',
      childMechanic: '',
      lastServiceMileageKnown: '',
      lastServiceMileage: '',
      lastServiceDate: '',
      motsIncluded: '',
      ...values,
    };

    if (data.newCar) {
      data.registration = data.regNum;
    }
    if (data.VRN2) {
      data.VRN2 = data.VRN2.toUpperCase().replace(/\s/g, '');
    }
    data.registration = data.registration.toUpperCase().replace(/\s/g, '');
    try {
      const result = await fetch('/provider/create-plan', {
        method: 'post',
        body: data,
      });
      this.props.saveQuote(values);
      this.props.dispatch(push(result.redirectUrl));
    } catch (result) {
      if (typeof result.error === 'object') {
        throw new SubmissionError(result.error);
      }
      throw new SubmissionError({ _error: result.error.toString() });
    }
  };

  normalizeNumberField = value => (value === 0 ? null : value);

  disabledDateLtNow = current => current && current < moment().endOf('day');

  packageCarsNumber = packageId =>
    pipe(
      find({ id: +packageId }),
      get('carsNumber'),
    )(this.state.plans);

  render() {
    const {
      fields: { PackageId },
    } = this.props;
    const packageCarsNumber = this.packageCarsNumber(PackageId);

    return (
      <form className={s.form} onSubmit={this.props.handleSubmit(this.submit)}>
        {packageCarsNumber === 2 && (
          <div className={`${s.form_row} ${s.form_row_checkbox}`}>
            <div />
            <h2 className={s.center}>First car</h2>
          </div>
        )}
        {!this.props.fields.newCar && (
          <Field
            name="registration"
            component={renderVRM}
            validate={this.constructor.validateNotBlank}
          />
        )}

        <Field
          label="Current Mileage"
          name="currentMileage"
          type="number"
          min={0}
          onWheel={e => e.preventDefault()}
          component={renderInput}
          parse={Number}
          normalize={this.normalizeNumberField}
          validate={[
            this.constructor.validateNotBlank,
            this.constructor.greaterThanZero,
          ]}
        />
        <Field
          label="Expected Annual Mileage"
          name="expectedMileage"
          component={renderInput}
          type="number"
          min={0}
          onWheel={e => e.preventDefault()}
          validate={this.constructor.validateNotBlank}
        />
        <Field
          label="Plan"
          name="PackageId"
          component={renderSelect}
          options={this.state.packageOptions}
          validate={[this.constructor.validateNotBlank]}
        />
        <Field
          label="Term"
          name="requestedServicesCount"
          component={renderSelect}
          options={this.term}
          validate={[
            this.constructor.validateNotBlank,
            this.constructor.validateCar,
          ]}
        />
        {!this.props.fields.newCar && (
          <div>
            <div className={`${s.form_row} ${s.form_row_checkbox}`}>
              <div />
              <div>
                <label htmlFor="lastServiceMileageKnown">
                  Last Service Date and Mileage Known
                </label>
                <input
                  id="lastServiceMileageKnown"
                  className={s.input_checkbox}
                  type="checkbox"
                  checked={this.props.fields.lastServiceMileageKnown}
                  onChange={this.setLastServiceMileageKnown}
                />
              </div>
            </div>
            {this.props.fields.lastServiceMileageKnown && (
              <div>
                <div className={`${s.form_row} ${s.form_row_checkbox}`}>
                  <div />
                  <div>
                    <label htmlFor="justServiced">Car Just Serviced</label>
                    <input
                      id="justServiced"
                      className={s.input_checkbox}
                      type="checkbox"
                      checked={this.props.fields.justServiced}
                      onChange={this.setJustServiced}
                    />
                  </div>
                </div>
                <Field
                  label="Last Service Mileage"
                  name="lastServiceMileage"
                  type="number"
                  min={0}
                  component={renderInput}
                  parse={Number}
                  normalize={this.normalizeNumberField}
                  validate={[
                    this.constructor.validateNotBlank,
                    this.validateLastMileage,
                  ]}
                  onWheel={e => e.preventDefault()}
                  props={{ disabled: this.props.fields.justServiced }}
                />
                <Field
                  label="Last Service Date"
                  name="lastServiceDate"
                  type="date"
                  component={renderInputDate}
                  validate={[
                    this.constructor.validateNotBlank,
                    this.constructor.validateDate,
                    this.constructor.lessThanNow,
                  ]}
                  props={{ disabled: this.props.fields.justServiced }}
                />
              </div>
            )}
          </div>
        )}
        {this.props.fields.motsIncluded && !this.props.fields.newCar && (
          <Field
            label="Next MOT Date (optional)"
            name="nextMOTDate"
            type="date"
            component={renderInputDate}
            disabledDate={this.disabledDateLtNow}
            validate={[this.constructor.validateOptionalDate]}
          />
        )}
        {packageCarsNumber === 2 && (
          <div>
            <div className={`${s.form_row} ${s.form_row_checkbox}`}>
              <div />
              <h2 className={s.center}>Second car</h2>
            </div>
            <Field
              name="VRN2"
              component={renderVRM}
              validate={this.constructor.validateNotBlank}
            />
            <Field
              label="Current Mileage"
              name="VRN2CurrentMileage"
              type="number"
              min={0}
              onWheel={e => e.preventDefault()}
              component={renderInput}
              parse={Number}
              normalize={this.normalizeNumberField}
              validate={[
                this.constructor.validateNotBlank,
                this.constructor.greaterThanZero,
              ]}
            />
            <Field
              label="Expected Annual Mileage"
              name="VRN2AnnualMileage"
              component={renderInput}
              type="number"
              min={0}
              onWheel={e => e.preventDefault()}
              validate={this.constructor.validateNotBlank}
            />

            <div className={`${s.form_row} ${s.form_row_checkbox}`}>
              <div />
              <div>
                <label htmlFor="VRN2LastServiceMileageKnown">
                  Last Service Date and Mileage Known
                </label>
                <input
                  id="VRN2LastServiceMileageKnown"
                  className={s.input_checkbox}
                  type="checkbox"
                  checked={this.props.fields.VRN2LastServiceMileageKnown}
                  onChange={this.setVRN2LastServiceMileageKnown}
                />
              </div>
            </div>
            {this.props.fields.VRN2LastServiceMileageKnown && (
              <div>
                <div className={`${s.form_row} ${s.form_row_checkbox}`}>
                  <div />
                  <div>
                    <label htmlFor="VRN2JustServiced">Car Just Serviced</label>
                    <input
                      id="VRN2JustServiced"
                      className={s.input_checkbox}
                      type="checkbox"
                      checked={this.props.fields.VRN2JustServiced}
                      onChange={this.setVRN2JustServiced}
                    />
                  </div>
                </div>
                <Field
                  label="Last Service Mileage"
                  name="VRN2LastServiceMileage"
                  type="number"
                  min={0}
                  component={renderInput}
                  parse={Number}
                  normalize={this.normalizeNumberField}
                  validate={[
                    this.constructor.validateNotBlank,
                    this.validateVRN2LastMileage,
                  ]}
                  onWheel={e => e.preventDefault()}
                  props={{ disabled: this.props.fields.VRN2JustServiced }}
                />
                <Field
                  label="Last Service Date"
                  name="VRN2LastServiceDate"
                  type="date"
                  component={renderInputDate}
                  validate={[
                    this.constructor.validateNotBlank,
                    this.constructor.validateDate,
                    this.constructor.lessThanNow,
                  ]}
                  props={{ disabled: this.props.fields.justServiced }}
                />
              </div>
            )}
            <Field
              label="Next MOT Date (optional)"
              name="VRN2nextMOTDate"
              type="date"
              component={renderInputDate}
              disabledDate={this.disabledDateLtNow}
              validate={[this.constructor.validateOptionalDate]}
            />
          </div>
        )}
        <Field
          label="Customer Email"
          name="customerEmail"
          type="email"
          component={renderInput}
          validate={this.constructor.validateNotBlank}
        />
        <button
          type="submit"
          className={s.submit}
          disabled={this.props.disabled}
        >
          {'Get Quote >>>'}
        </button>
        {this.props.error && <Alert message={this.props.error} type="error" />}
      </form>
    );
  }
}

const mapStateToProps = ({ plan }) => ({
  initialValues: {
    motsIncluded: true,
    PackageId: '1',
    newCar: false,
    paymentType: 2,
    requestedServicesCount: 1,
    ...(plan.useSavedFormFields ? plan.savedPlanFormFields : {}),
  },
});

export default compose(
  connect(
    mapStateToProps,
    {
      setUseSavedQuote: planActions.setUseSavedPlanFormFields,
      saveQuote: planActions.savePlanFormFields,
    },
  ),
  reduxForm({
    form: formName,
  }),
  withFormValues({ propName: 'fields' }),
  lifecycle({
    componentWillUnmount() {
      this.props.setUseSavedQuote(false);
    },
  }),
)(NewSpForm);
